import { dayjsUtils } from '@shared/utils/helpers/dayjs';

/** "11 Sep 2026 - 12:38 am", the stamp every content card carries. */
export const formatKnowledgeDate = (iso: string) =>
  dayjsUtils(iso).format('D MMM YYYY - h:mm a');
